module.exports = __webpack_public_path__ + "static/media/result_fhl_ja.f79258ec.jpg";